import { Card, Container, Text, Title } from "@mantine/core";
import { useLocation } from "react-router-dom";

export default function Placeholder() {
  const location = useLocation();
  return (
    <Container>
      <Card ta="center" py="xl">
        <Title order={1} variant="gradient">
          Placeholder Page
        </Title>

        <Text mt="xl" size="xl">
          Currently in: {location.pathname}
        </Text>
      </Card>
    </Container>
  );
}
